var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYourChallengeImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.999 3a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M.832 10.5a9.167 9.167 0 1 1 18.333 0 9.167 9.167 0 0 1-18.333 0m9.167-5c.46 0 .833.373.833.833v5a.833.833 0 0 1-1.667 0v-5c0-.46.373-.833.834-.833m1.041 8.958a1.042 1.042 0 1 1-2.083 0 1.042 1.042 0 0 1 2.083 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#info_svg__a)",
    d: "M9.999 3a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M.832 10.5a9.167 9.167 0 1 1 18.333 0 9.167 9.167 0 0 1-18.333 0m9.167-5c.46 0 .833.373.833.833v5a.833.833 0 0 1-1.667 0v-5c0-.46.373-.833.834-.833m1.041 8.958a1.042 1.042 0 1 1-2.083 0 1.042 1.042 0 0 1 2.083 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "info_svg__a",
    x1: 9.999,
    x2: 9.999,
    y1: 1.333,
    y2: 19.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E98363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E25F36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourChallengeImage);
export default __webpack_public_path__ + "static/media/your-challenge-image.adff7a7084c0a722a765866e5570f246.svg";
export { ForwardRef as ReactComponent };